import { Route, Switch } from 'react-router-dom';

import HomePage from './pages/Home';
import InviteExpiredPage from './pages/InviteExpired';
import NotFoundPage from './pages/NotFound';
import SharedSessionsPage from 'pages/SharedSessions';
import UsersPage from './pages/Users';
import ClientsPage from "./pages/DataIntegration";

export const DefaultRoutes = {
  HomePage: '/',
  UsersPage: '/users',
  DataIntegrationPage: '/dataIntegration',
  InviteExpiredPage: '/invite_expired',
  SharedSessionsPage: '/sharedsession',
} as const;

export const routes = (
  <Switch>
    <Route exact path={DefaultRoutes.HomePage} component={HomePage} />
    <Route exact path={DefaultRoutes.UsersPage} component={UsersPage} />
    <Route exact path={DefaultRoutes.DataIntegrationPage} component={ClientsPage}/>
    <Route exact path={DefaultRoutes.InviteExpiredPage} component={InviteExpiredPage} />
    <Route exact path={`${DefaultRoutes.SharedSessionsPage}/:shareCode`} component={SharedSessionsPage} />
    <Route component={NotFoundPage} />
  </Switch>
);

export const UnauthanticatedRoutes = ['sharedsession'];

export const isCurrentRouteUnauth = () => {
  const currentRoute = window.location.pathname;
  const isUnauth = UnauthanticatedRoutes.some((route) => currentRoute.match(route));
  return isUnauth;
};
